export default __webpack_public_path__ + "static/GA-horiz-24c0d652d3b3c4b1f5f79644b45fdc4a.svg";